import { ProductDto } from "../../../../api-clients/composition";
import "./cards.scss";


export interface ProductCardProps {
    product:  ProductDto
  }

function ProductCard({ product } : ProductCardProps) {
   // const {goToDetailProduct } = useProductService();

    const handleProductDetails = () => {
    //    goToDetailProduct( product.id );
    };

    const { image = 'empty', name = "Product"} = product || {};
    const price = 324.23;
  
    return (
        <>
        {product?.id ? (
            <div className='ai-card'>
                <img alt={name} className='productImage' src={image} />
                <h3 className='productName'>{name}</h3>
                <p className='productPrice'>${price.toFixed(2)}</p>
                <button className='primaryButton' onClick={handleProductDetails}>
                    View Product
                </button>
            </div>) : 
            (
            <div className="ai-card">
                 <h3 className='productName'>Loading...</h3>
            </div>
            )}
      </>
    );
  };


export default ProductCard;
